<template>
    <div>
       <Row type="flex" justify="center" class="code-row-bg headtop">
           <Col span="24"><img src="../../assets/images/news/new_top.png"/></Col>
       </Row>
       <Row type="flex" justify="start" class="code-row-bg">
           <Col span="24"  class="demo-tabs-style1" style="background: #e3e8ee;padding:16px;">
           <Tabs type="card" v-model="tabValue" :animated="false" @on-click="tabChange">
               <TabPane v-for="item in tabList" :key="item.key" :label="item.name" :name ='item.key'>
                   <Row>
                       <Col span="24" class="head">
                       <List item-layout="vertical" v-if="dataList.length>0">
                           <ListItem v-for="(item ,index) in dataList" :key="index">
                               <Row>
                                   <div @click="detailclick(item)">
                                       <Col span="22">
                                       {{item.title}}
                                       </Col>
                                       <Col span="2">
                                       <span style="color: #9ca3ac">{{item.releaseTime}}</span>
                                       </Col>
                                   </div>
                               </Row>
                           </ListItem>
                       </List>
                       <div v-else>暂无数据</div>
                       <div class="table-bottom">
                           <div class="table-btmRight">
                               <Page :total="totalCount"
                                     @on-change="goPage"
                                     :page-size="pageSize"
                                     :current="currentPage"
                                     @on-page-size-change="sizeChange"
                                     size="small" show-elevator show-sizer
                               ></Page>
                           </div>
                       </div>
                       </Col>
                   </Row>
               </TabPane>
           </Tabs>
           </Col>
       </Row>
    </div>
</template>

<script>
    import {newUrl} from '@/assets/js/newurl.js'
    export default {
        name: "news-info",
        data () {
            return {
                dataTable:{},
                totalCount: 0,
                pageSize: 10,
                currentPage: 1,
                tabList:[
                    {name:'动态要闻',key:'newsdynamic'},
                    {name:'政策法规',key:'policiesregulations'},
                    {name:'通知公告',key:'announcements'},
                ],
                tabValue:'newsdynamic',
                chooseType:1,
                dataList: [],
                loginData:''
            }
        },
        mounted(){
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
            this.getnewList();
        },
        methods:{
            goPage(val){
                this.currentPage=val;
                this.getnewList();
            },
            sizeChange(val){
                this.pageSize=val;
                this.getnewList();
            },
            tabChange(val) {
                if (val=='newsdynamic') {
                    this.chooseType=1;
                }else if(val=='policiesregulations'){
                    this.chooseType=2;
                }
                else if(val=='announcements'){
                    this.chooseType=3;
                }
                this.dataList=[];
                this.totalCount=0;
                this.currentPage=1;
                this.pageSize=10;
                //获取新闻列表
                this.getnewList();
            },
            getnewList(){
                var that=this;
                this.$axios.get(newUrl+'/bbs/news', {
                    params: {
                        type:this.chooseType,
                        pageSize:this.pageSize,
                        pageNum:this.currentPage,
                        areaId:this.loginData.areaId

                    }
                }).then(function (response) {
                    if(response.data.success){
                        that.dataList=response.data.data
                        that.totalCount=response.data.totalCount;
                    }
                }).catch(function (error) {
                    alert(error);
                });
            },
            detailclick(item){
                let routeData = this.$router.resolve({ name: 'news-detail', query: {  id: item.id} });
                window.open(routeData.href, '_blank');

            }
        }
    }
</script>

<style scoped>
.headtop{
    height: 278px;
    margin-bottom: 20px;
    background-color: #c5d6f3;
}
.demo-tabs-style1 > .ivu-tabs-card > .ivu-tabs-content {
    height: 120px;
    margin-top: -16px;
}
.demo-tabs-style1 > .ivu-tabs-card > .ivu-tabs-content > .ivu-tabs-tabpane {
    background: #fff;
    padding: 16px;
}
.demo-tabs-style1 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    border-color: transparent;
}
.demo-tabs-style1 > .ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
    border-color: #fff;
}
.table-bottom {
    margin-top: 20px;
    height: 35px;
    padding-right: 20px;
    width: 100%;
    overflow: hidden;
}
.table-btmRight {
    float: right;
}
/deep/ .ivu-tabs-tabpane{
    height: 600px;
    overflow-y: auto;
}
/deep/ .ivu-select-dropdown {
    background-color: #ffffff !important;
}
/deep/ .ivu-select-item{
   color: #333 !important;
}
/deep/ .ivu-select-selection{
   background-color: #ffffff !important;
   color: #333 !important;
}
/deep/ .ivu-select-item-focus{
    background-color: #ffffff !important;
}
/deep/ .ivu-select-item:hover{
    background-color: #ffffff !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/index/news-info.vue